var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8,4.5c-0.3,0-0.5,0.1-0.7,0.4C2,5.1,2,5.4,2.1,5.6C2.2,5.9,2.5,6,2.8,6h18.5c0.3,0,0.5-0.1,0.7-0.4 c0.1-0.2,0.1-0.5,0-0.8c-0.1-0.2-0.4-0.4-0.7-0.4H2.8z M2.8,11.3c-0.3,0-0.5,0.1-0.7,0.4c-0.1,0.2-0.1,0.5,0,0.8 c0.1,0.2,0.4,0.4,0.7,0.4h18.5c0.3,0,0.5-0.1,0.7-0.4c0.1-0.2,0.1-0.5,0-0.8s-0.4-0.4-0.7-0.4H2.8z M2.8,18c-0.3,0-0.5,0.1-0.7,0.4 c-0.1,0.2-0.1,0.5,0,0.8c0.1,0.2,0.4,0.4,0.7,0.4h18.5c0.3,0,0.5-0.1,0.7-0.4c0.1-0.2,0.1-0.5,0-0.8S21.5,18,21.2,18H2.8z M2.8,4.5 c-0.3,0-0.5,0.1-0.7,0.4C2,5.1,2,5.4,2.1,5.6C2.2,5.9,2.5,6,2.8,6h18.5c0.3,0,0.5-0.1,0.7-0.4c0.1-0.2,0.1-0.5,0-0.8 c-0.1-0.2-0.4-0.4-0.7-0.4H2.8z M2.8,11.3c-0.3,0-0.5,0.1-0.7,0.4c-0.1,0.2-0.1,0.5,0,0.8c0.1,0.2,0.4,0.4,0.7,0.4h18.5 c0.3,0,0.5-0.1,0.7-0.4c0.1-0.2,0.1-0.5,0-0.8s-0.4-0.4-0.7-0.4H2.8z M2.8,18c-0.3,0-0.5,0.1-0.7,0.4c-0.1,0.2-0.1,0.5,0,0.8 c0.1,0.2,0.4,0.4,0.7,0.4h18.5c0.3,0,0.5-0.1,0.7-0.4c0.1-0.2,0.1-0.5,0-0.8S21.5,18,21.2,18H2.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMenu);
export default __webpack_public_path__ + "static/media/ico-menu.32ebdd9cb944dce2791f446dc866c1af.svg";
export { ForwardRef as ReactComponent };